import { useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';
import { NoteEmployeeUuidResponse } from '../../../types/Note';

const fetchNoteEmployeeUuids = async (uuid: string, action: string) => {
  const response = await CustomAxios.get<NoteEmployeeUuidResponse>(`notes/${uuid}/employee_uuids?note_action=${action}`);
  const { data } = response;
  return data;
};

interface UseGetNoteEmployeeUuidsByIdProps {
  uuid: string;
  action: string;
  enabled?: boolean;
}

export function useGetNoteEmployeeUuidsById({ uuid, action, enabled = true }: UseGetNoteEmployeeUuidsByIdProps) {
  const query = useQuery({
    enabled,
    queryKey: [queryKeys.noteEmployeeUuids, uuid],
    queryFn: () => fetchNoteEmployeeUuids(uuid, action),
  });

  return query;
}
